
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[organizationName]",
      function () {
        return require("private-next-pages/[organizationName]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[organizationName]"])
      });
    }
  